import { VueQueryPlugin, QueryClient } from "@tanstack/vue-query";

// Create a query client with custom configuration
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Retry failed requests 3 times
      retry: 3,
      // Retry only on server errors (5xx) or network errors
      retryOnMount: true,
      // Stale time - how long data is considered fresh
      staleTime: 5 * 60 * 1000, // 5 minutes
      // Cache time - how long to keep data in cache
      gcTime: 10 * 60 * 1000, // 10 minutes
      // Refetch on window focus
      refetchOnWindowFocus: true,
      // Refetch on reconnect
      refetchOnReconnect: true,
    },
    mutations: {
      // Retry failed mutations
      retry: 1,
    },
  },
});

// Custom retry logic that only retries on server errors
export const customRetry = (failureCount: number, error: any) => {
  // Don't retry more than 3 times
  if (failureCount >= 3) return false;

  // Only retry on server errors (5xx) or network errors
  if (error?.status && typeof error.status === "string") {
    if (error.status.startsWith("5") || error.status === "0") {
      return true;
    }
  }

  // Don't retry on client errors (4xx)
  return false;
};

export { VueQueryPlugin };
